module.exports = __webpack_public_path__ + "img/116.5248a6a5.jpg";